export const categoryAdvisoryText = `Warning: This category has entries associated with it. If you continue with deletion,
these entries will all be assigned to the '(Unassigned)' category`;
